export default __webpack_public_path__ + "static/media/HDTX_The Invitation of GMS 30 Juni 2025.ff720a04.pdf";